<template>
  <v-layout wrap>
    <v-flex xs12 md3 order-md1 order-xs2>
      <v-card-text>
        <flat-pickr
          v-show="false"
          v-model="date"
          @on-close="onDateRangeChange"
          :config="dateRangeConfig"
          ref="datePickerWrap"
          name="date">
        </flat-pickr>
        <v-chip outline color="primary" data-toggle @click="openDate" id="myDate">
          <v-icon left>mdi-calendar-range</v-icon>
          {{ showDate }}
        </v-chip>
      </v-card-text>
    </v-flex>

    <v-flex xs12 md9 order-md2 order-xs1>
      <v-card-text class="text-md-right">
        <template v-if="!isLoadingInitialInfo">
          <v-layout justify-end align-center wrap d-inline-flex>
            <v-flex order-sm1 class="text-xs-center text-sm-left">
              <span v-html="formatLastConfirmation" style="margin-right: 5px;"></span>
            </v-flex>
            <v-flex order-sm2 class="text-xs-center text-sm-left">
              <span>Итог: <b>{{currentBalance}}</b></span>
              <v-tooltip bottom>
                <v-btn
                  flat
                  icon
                  slot="activator"
                  color="primary"
                  style="top:-4px;"
                  @click="openConfirmationModal"
                >
                  <v-icon>mdi-thumb-up</v-icon>
                </v-btn>
                <span>Подтвердить</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </template>
        <template v-else>
          <v-progress-circular
            indeterminate
            :size="20"
            :width="2"
            color="secondary"
          ></v-progress-circular>
        </template>
      </v-card-text>
    </v-flex>
    <balance-confirmation-modal
      ref="balanceConfirmationModal"
      @confirm="confirmBalance"
    />
  </v-layout>
</template>

<script>
import BalanceApi from '../api'
import BalanceConfirmationModal from './BalanceConfirmationModal'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Russian } from 'flatpickr/dist/l10n/ru'
import { split as splitString } from 'lodash'
import { format } from 'date-fns'

export default {
  name: 'BalanceToolbar',
  components: {
    BalanceConfirmationModal,
    flatPickr
  },
  data () {
    return {
      format,
      date: `${format(new Date(), 'YYYY-MM-DD')} - ${format(new Date(), 'YYYY-MM-DD')}`,
      isLoadingInitialInfo: false,
      currentBalance: null,
      lastConfirmation: null,
      dateRangeConfig: {
        enableTime: false,
        dateFormat: 'Y-m-d',
        mode: 'range',
        wrap: true,
        locale: Russian
      }
    }
  },
  computed: {
    formatLastConfirmation () {
      if (this.lastConfirmation) {
        return `Подтверждено: <b>${this.lastConfirmation.summa}</b> от <b>${this.lastConfirmation.created_on}</b>.`
      } else {
        return '-'
      }
    },
    showDate () {
      const currentRange = this.date
      let formatedRange = splitString(currentRange, ' - ')
      return `${format(formatedRange[0], 'DD.MM.YYYY')} - ${format(formatedRange[1] || formatedRange[0], 'DD.MM.YYYY')}`
    }
  },
  methods: {
    async loadInitialInfo () {
      this.isLoadingInitialInfo = true
      try {
        let response = await BalanceApi.getInfo()
        if (response.success) {
          this.lastConfirmation = response.lastConfirmation
          this.currentBalance = response.currentBalance
        }
      } catch (error) {
      } finally {
        this.isLoadingInitialInfo = false
      }
    },
    openConfirmationModal () {
      this.$refs.balanceConfirmationModal.open()
    },
    openDate () {
      const flatPickrInstance = this.$refs.datePickerWrap.fp
      flatPickrInstance._positionElement = window.document.getElementById('myDate') // eslint-disable-line
    },
    async confirmBalance () {
      this.isLoadingInitialInfo = true
      try {
        let response = await BalanceApi.confirmBalance()
        if (response.success) {
          this.lastConfirmation = response.lastConfirmation
          this.currentBalance = response.currentBalance
        }
      } catch (error) {
      } finally {
        this.isLoadingInitialInfo = false
      }
    },
    onDateRangeChange (selectedDates) {
      this.$router.replace({
        name: 'balance',
        params: {},
        query: {
          from: format(selectedDates[0], 'YYYY-MM-DD'),
          to: format(selectedDates[1] || selectedDates[0], 'YYYY-MM-DD')
        }
      })
      this.$emit('updateDocumentsList', selectedDates)
    }
  },
  beforeMount () {
    Russian.rangeSeparator = ' - '
    if (this.$route.query.from && this.$route.query.to) {
      this.date = `${format(new Date(this.$route.query.from), 'YYYY-MM-DD')} - ${format(new Date(this.$route.query.to), 'YYYY-MM-DD')}`
    }
    this.loadInitialInfo()
  }
}
</script>

<style scoped>

</style>
